import React from 'react'
import { Col, Card, Space, Table, Progress, Tag } from 'antd'
import { MedicineBoxOutlined } from '@ant-design/icons'

const DepartmentStatus = ({ departmentSummary }) => {
  const columns = [
    { title: 'Department', dataIndex: 'department' },
    {
      title: 'Occupancy',
      dataIndex: 'occupancy',
      render: (occupancy) => (
        <Progress
          percent={occupancy}
          size='small'
          strokeColor={occupancy > 90 ? '#f5222d' : occupancy > 75 ? '#fa8c16' : '#52c41a'}
        />
      )
    },
    {
      title: "Today's Admissions",
      dataIndex: 'admissionsToday',
      render: (value) => <Tag color='blue'>{value}</Tag>
    },
    {
      title: 'Expected Discharges',
      dataIndex: 'dischargesExpected',
      render: (value) => <Tag color='green'>{value}</Tag>
    }
  ]

  return (
    <Col xs={24} md={16}>
      <Card
        title={
          <Space>
            <MedicineBoxOutlined /> Department Status
          </Space>
        }
        size='small'
      >
        <Table dataSource={departmentSummary} rowKey='department' size='small' pagination={false} columns={columns} />
      </Card>
    </Col>
  )
}

export default DepartmentStatus
